import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import TreeNodeViewModel from "./../../factories/tree-node";
import "./../../bindings/bao-tree";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-searcher";
function ExpandedSearchInstruction(parent) {
    var self = this;
    var htmlUrl = "ExpandedSearch/ExpandedInstruction";
    self.LoadHtml = function () {
        return Bao.get(htmlUrl, function (result) {
            Bao.Templates[htmlUrl] = result;
            parent.ExpandedSearchTemplateName(htmlUrl);
        });
    };
    self.Categories = ko.observableArray([]);
    self.DateFilterTypes = ko.observableArray([]);
    self.DateFromHtml = ko.observable();
    self.DateFromHtml.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.DateToHtml = ko.observable();
    self.DateToHtml.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedAreas = ko.observableArray([]);
    self.AreaName = ko.observable();
    self.AreaId = ko.observable();
    self.AreaId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedAreaEquipments = ko.observableArray([]);
    self.EquipmentName = ko.observable();
    self.AreaEquipmentId = ko.observable();
    self.AreaEquipmentId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedDevice3s = ko.observableArray([]);
    self.Device3Name = ko.observable();
    self.Device3Id = ko.observable();
    self.Device3Id.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedDevice4s = ko.observableArray([]);
    self.Device4Name = ko.observable();
    self.Device4Id = ko.observable();
    self.Device4Id.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.IncludeSubCategories = ko.observable(false);
    self.IncludeSubCategories.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.CategoryStructureId = ko.observable();
    self.CategoryStructureId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.DateFilterTypeKey = ko.observable();
    self.DateFilterTypeKey.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedInfoLevels = ko.observableArray([]);
    self.InfoLevelName = ko.observable();
    self.InfoLevelId = ko.observable();
    self.InfoLevelId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.SelectedInfoStates = ko.observableArray([]);
    self.InfoStateName = ko.observable();
    self.InfoStateId = ko.observable();
    self.InfoStateId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.GetCategories = function () {
        var self = this;
        return Bao.post("Information/GetAllCategories", JSON.stringify({})).then(function (result) {
            ko.map.fromJS(result, self.Categories);
        });
    };
    self.GetDateFilterTypes = function () {
        var self = this;
        return Bao.post("ExpandedSearch/GetExpandedInstructionDateFilterType", JSON.stringify({})).then(function (result) {
            ko.map.fromJS(result, self.DateFilterTypes);
        });
    };
    self.GetCustomFilter = function () {
        if (self.AreaId() == null && self.AreaEquipmentId() == null && self.Device3Id() == null && self.Device4Id() == null && self.CategoryStructureId() == null && self.IncludeSubCategories() == false && self.InfoLevelId() == null && Bao.Utils.String.IsNullOrWhitespace(self.DateFromHtml()) && Bao.Utils.String.IsNullOrWhitespace(self.DateToHtml())) {
            return null;
        }
        else {
            return {
                DateFrom: JSON.stringify(self.DateFromHtml()),
                DateTo: JSON.stringify(self.DateToHtml()),
                AreaId: JSON.stringify(self.AreaId()),
                AreaEquipmentId: JSON.stringify(self.AreaEquipmentId()),
                Device3Id: JSON.stringify(self.Device3Id()),
                Device4Id: JSON.stringify(self.Device4Id()),
                CategoryStructureId: JSON.stringify(self.CategoryStructureId()),
                IncludeSubCategories: JSON.stringify(self.IncludeSubCategories()),
                InfoLevelId: JSON.stringify(self.InfoLevelId()),
                DateFilterType: JSON.stringify(self.DateFilterTypeKey())
            };
        }
    };
    self.init = function () {
        return $.when(self.LoadHtml(), self.GetCategories(), self.GetDateFilterTypes());
    };
}
export default ExpandedSearchInstruction;